// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qe8TS","placeholdersHeader":"styles_placeholdersHeader__1FAgJ","editorStyle":"styles_editorStyle__99DaO","placeholdersBox":"styles_placeholdersBox__3ABrq"};